import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { formatCurrency } from '../lib/db'
import './Profile.css'

export default function Profile() {
    const { user, signOut, isAdmin } = useAuth()

    if (!user) {
        return null
    }

    return (
        <div className="container">
            <div className="profile-page">
                <h1 className="page-title">My Profile</h1>

                {/* Profile Card */}
                <div className="profile-card">
                    <div className="profile-header">
                        <img
                            src={user.picture}
                            alt={user.name}
                            className="profile-avatar"
                            referrerPolicy="no-referrer"
                        />
                        <div className="profile-info">
                            <h2 className="profile-name">{user.name}</h2>
                            <p className="profile-email">{user.email}</p>
                            {isAdmin && <span className="admin-badge">🛡️ Admin</span>}
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="profile-stats">
                        <div className="stat-item">
                            <span className="stat-icon">🪙</span>
                            <span className="stat-value">{user.s_coins || 0}</span>
                            <span className="stat-label">S-Coins</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-icon">⭐</span>
                            <span className="stat-value">{user.loyalty_points || 0}</span>
                            <span className="stat-label">Loyalty Points</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-icon">💰</span>
                            <span className="stat-value">{formatCurrency(Math.floor((user.s_coins || 0) / 100) * 10)}</span>
                            <span className="stat-label">Wallet Value</span>
                        </div>
                    </div>
                </div>

                {/* Quick Links */}
                <div className="profile-links">
                    <Link to="/orders" className="profile-link">
                        <span className="link-icon">📦</span>
                        <span className="link-text">My Orders</span>
                        <span className="link-arrow">→</span>
                    </Link>
                    <Link to="/wallet" className="profile-link">
                        <span className="link-icon">🪙</span>
                        <span className="link-text">S-Coins Wallet</span>
                        <span className="link-arrow">→</span>
                    </Link>
                    <Link to="/cart" className="profile-link">
                        <span className="link-icon">🛒</span>
                        <span className="link-text">Shopping Cart</span>
                        <span className="link-arrow">→</span>
                    </Link>
                    {isAdmin && (
                        <Link to="/admin" className="profile-link admin-link">
                            <span className="link-icon">🛡️</span>
                            <span className="link-text">Admin Panel</span>
                            <span className="link-arrow">→</span>
                        </Link>
                    )}
                </div>

                {/* Sign Out */}
                <button className="btn btn-secondary btn-lg signout-btn" onClick={signOut}>
                    Sign Out
                </button>
            </div>
        </div>
    )
}
